import React from 'react';
import { signerContext } from './context';
import Field from './signer-field';

export default function wrapPage(DisplayPage) {

  return function Page(props) {
    const { onPageClick } = React.useContext(signerContext);

    return (
      <DisplayPage
        {...props}
        Field={Field}
        onPageClick={onPageClick} />
    );
  };
}
